import React from 'react';
import './Footer.scss';

const Footer = ({ logo, children }) => (
    <div className="footer">
        <div className="content">
            <img src={logo} alt="logo" className="logo" />
            {children}
        </div>
        <svg viewBox="-2990 2800 1920.016 540.091" className="rotated">
            <path className="backgroundColor" d="M-.016,180.043l1920-.091L1920,474,0,720.043Z" transform="translate(-1070 3520.043) rotate(180)" />
        </svg>
    </div>
);
export default Footer;


// WEBPACK FOOTER //
// ./src/components/ui/Footer/Footer.js